function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var sizes = {
  small: 56,
  medium: 144,
  large: 260
};
var useStyles = _ref => {
  var {
    appearance,
    expanded,
    isFixed,
    position,
    responsiveBreakpoint,
    size
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var iconPreview = size === 'small';
    var isHc = theme.mode === 'contrast';
    var width = sizes[size];
    if (iconPreview) {
      width = expanded ? sizes.large : sizes.small;
    }
    return {
      root: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        backgroundColor: theme.palette.background.container,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        position,
        transition: iconPreview ? 'width 500ms ease' : undefined,
        width
      }, isFixed && {
        bottom: 0,
        left: 0,
        top: 0,
        zIndex: theme.elevation.sideMenu
      }), (appearance === 'outlined' || isHc) && {
        borderColor: isHc ? theme.palette.foreground.default : theme.palette.stroke.default,
        borderStyle: 'solid',
        borderWidth: '1px'
      }), appearance === 'dropShadow' && {
        boxShadow: theme.level.level8
      }), highContrastMediaQuery(theme)), size !== 'small' && {
        ["@media (max-width: ".concat(responsiveBreakpoint, ")")]: {
          left: expanded ? 0 : "calc(-".concat(width, "px - ").concat(theme.layout.size1, ")"),
          transition: 'left 300ms ease'
        }
      }),
      nav: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: "".concat(theme.layout.size2, " 0"),
        width,
        ul: {
          listStyle: 'none'
        }
      },
      appHeaderContainer: {
        alignItems: 'center',
        borderBottom: "1px solid ".concat(theme.palette.stroke.default),
        boxSizing: 'border-box',
        display: 'flex',
        padding: "".concat(theme.layout.size1, " 0 calc(").concat(theme.layout.size1, " - 1px)"),
        width: '100%'
      },
      appHeader: {
        padding: "0 ".concat(theme.layout.size1),
        flexGrow: 1,
        'div[role="button"]': {
          justifyContent: 'flex-start'
        }
      },
      closeButton: {
        marginLeft: theme.layout.size1,
        marginRight: theme.layout.size3
      },
      toggleAppHeader: _objectSpread(_objectSpread({
        alignItems: 'center',
        display: 'none',
        height: "calc(".concat(sizes.small, "px + ").concat(theme.layout.size3, ")"),
        justifyContent: 'center',
        left: 0,
        position: isFixed ? position : 'absolute',
        top: 0,
        width: sizes.small
      }, isFixed && {
        zIndex: theme.elevation.sideMenu
      }), {}, {
        '> button': {
          margin: 0
        },
        '> div': {
          display: 'none'
        },
        ["@media (max-width: ".concat(responsiveBreakpoint, ")")]: {
          display: 'flex'
        }
      }),
      overlay: {
        backdropFilter: "blur(".concat(theme.level.glasswall.blur, ")"),
        backgroundColor: theme.level.glasswall.color,
        bottom: 0,
        left: 0,
        opacity: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        transition: 'opacity 300ms linear',
        visibility: 'hidden',
        zIndex: theme.elevation.sideMenu,
        ["@media (max-width: ".concat(responsiveBreakpoint, ")")]: {
          opacity: expanded ? 1 : 0,
          visibility: expanded ? 'inherit' : 'hidden'
        }
      }
    };
  }, [appearance, expanded, isFixed, position, responsiveBreakpoint, size, theme]);
};
export default useStyles;